module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('div', {
    staticClass: "primary"
  }, [_c('v-subheader', {
    staticClass: "event",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "8ex",
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/event2.png"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "event",
    staticStyle: {
      "color": "white",
      "psition": "relative",
      "bottom": "10px"
    }
  }, [_vm._v("Personal Calender\n      ")])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "box": "",
      "placeholder": "Search an event, project, or todo..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "height": "150%",
      "width": "200%",
      "events": _vm.functionEvents,
      "event-color": function (date) { return _vm.colorPicker(date); },
      "landscape": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.events), function(event) {
    return [(_vm.show[event.date]) ? _c('v-list-tile', {
      key: event.id,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          _vm.pushProject(event.projectID)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": event.icon
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(event.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(event.projectTitle)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(event.date)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(event.time)
      }
    })], 1)], 1) : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2ec7258","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calender.vue
// module id = 96
// module chunks = 12